import { render } from "./AddMaterial.vue?vue&type=template&id=88be2b8a&scoped=true"
import script from "./AddMaterial.vue?vue&type=script&lang=js"
export * from "./AddMaterial.vue?vue&type=script&lang=js"

import "./AddMaterial.vue?vue&type=style&index=0&id=88be2b8a&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88be2b8a"]])

export default __exports__